var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#paint0_linear_719_522)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6923 21.3008C41.2516 20.4997 43.8333 23.5587 43.8333 26.5832V53.4165C43.8333 56.441 41.2516 59.5 37.6923 58.6988C29.1402 56.7745 22.75 49.1347 22.75 39.9998C22.75 30.865 29.1402 23.2252 37.6923 21.3008ZM48.2283 32.8947C48.5877 32.5354 49.0751 32.3336 49.5833 32.3336C50.0916 32.3336 50.579 32.5354 50.9384 32.8947L56.6884 38.6447C57.0477 39.0042 57.2496 39.4916 57.2496 39.9998C57.2496 40.5081 57.0477 40.9955 56.6884 41.3549L50.9384 47.1049C50.5769 47.4541 50.0928 47.6472 49.5902 47.6429C49.0877 47.6385 48.607 47.4369 48.2516 47.0816C47.8962 46.7262 47.6947 46.2455 47.6903 45.7429C47.6859 45.2404 47.8791 44.7562 48.2283 44.3947L50.7065 41.9165H34.25C33.7417 41.9165 33.2542 41.7146 32.8947 41.3551C32.5353 40.9957 32.3333 40.5082 32.3333 39.9998C32.3333 39.4915 32.5353 39.004 32.8947 38.6445C33.2542 38.2851 33.7417 38.0832 34.25 38.0832H50.7065L48.2283 35.6049C47.8689 35.2455 47.6671 34.7581 47.6671 34.2498C47.6671 33.7416 47.8689 33.2542 48.2283 32.8947Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_522",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771414"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.cdcd208e66983ec3ce3eb3924016ad16.svg";
export { ForwardRef as ReactComponent };